import type { HTMLAttributes, ReactNode } from "react";

const widthClasses = {
  narrow: "max-w-3xl",
  default: "max-w-5xl",
  wide: "max-w-6xl",
  full: "max-w-none",
} as const;

const paddingYClasses = {
  none: "",
  sm: "py-6 sm:py-8",
  md: "py-8 sm:py-12",
  lg: "py-12 sm:py-16",
} as const;

export interface PageContainerProps extends HTMLAttributes<HTMLDivElement> {
  width?: keyof typeof widthClasses;
  paddingY?: keyof typeof paddingYClasses;
  children: ReactNode;
}

export function PageContainer({
  width = "default",
  paddingY = "md",
  children,
  className,
  ...props
}: PageContainerProps) {
  const classes = [
    widthClasses[width],
    "mx-auto px-4 sm:px-6",
    paddingYClasses[paddingY],
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
}
